<div class="gsm-form-nachbringen-aktinformationen_container" *ngIf="aktInfo">
  <div class="gsm-form-nachbringen-aktinformationen_element" *ngIf="aktInfo.meldeDatum">
    <div class="gsm-form-nachbringen-aktinformationen_bezeichnung">
      <p>Polizzenadresse:</p>
    </div>
    <div class="gsm-form-nachbringen-aktinformationen_wert">
      <p>{{ aktInfo.polizzenadresse }}</p>
    </div>
  </div>
  <div class="gsm-form-nachbringen-aktinformationen_element" *ngIf="aktInfo.meldeDatum">
    <div class="gsm-form-nachbringen-aktinformationen_bezeichnung">
      <p>Meldedatum:</p>
    </div>
    <div class="gsm-form-nachbringen-aktinformationen_wert">
      <p>{{ aktInfo.meldeDatum | amDateFormat: 'DD.MM.YYYY' }}</p>
    </div>
  </div>
  <div class="gsm-form-nachbringen-aktinformationen_element" *ngIf="aktInfo.vertragsSparte">
    <div class="gsm-form-nachbringen-aktinformationen_bezeichnung">
      <p>Vertragssparte:</p>
    </div>
    <div class="gsm-form-nachbringen-aktinformationen_wert">
      <p>{{ aktInfo.vertragsSparte }}</p>
    </div>
  </div>
  <div class="gsm-form-nachbringen-aktinformationen_element" *ngIf="aktInfo.schadenUrsache">
    <div class="gsm-form-nachbringen-aktinformationen_bezeichnung">
      <p>Schadenursache:</p>
    </div>
    <div class="gsm-form-nachbringen-aktinformationen_wert">
      <p>{{ aktInfo.schadenUrsache }}</p>
    </div>
  </div>
  <div class="gsm-form-nachbringen-aktinformationen_element" *ngIf="aktInfo.kfzKennzeichen">
    <div class="gsm-form-nachbringen-aktinformationen_bezeichnung">
      <p>KFZ Kennzeichen:</p>
    </div>
    <div class="gsm-form-nachbringen-aktinformationen_wert">
      <p>{{ aktInfo.kfzKennzeichen }}</p>
    </div>
  </div>
  <div class="gsm-form-nachbringen-aktinformationen_element" *ngIf="aktInfo.schadenStatus">
    <div class="gsm-form-nachbringen-aktinformationen_bezeichnung">
      <p>Status:</p>
    </div>
    <div class="gsm-form-nachbringen-aktinformationen_wert">
      <p>{{ aktInfo.schadenStatus }}</p>
    </div>
  </div>
  <div class="gsm-form-nachbringen-aktinformationen_element" *ngIf="aktInfo.checkListStatus">
    <div class="gsm-form-nachbringen-aktinformationen_bezeichnung">
      <p>Checklisten Status:</p>
    </div>
    <div class="gsm-form-nachbringen-aktinformationen_wert">
      <p>{{ convertToCheckListStatusText(aktInfo.checkListStatus) }}</p>
    </div>
  </div>
  <div class="gsm-form-nachbringen-aktinformationen_element" *ngIf="aktInfo.referent">
    <div class="gsm-form-nachbringen-aktinformationen_bezeichnung">
      <p>Referent:</p>
    </div>
    <div class="gsm-form-nachbringen-aktinformationen_wert">
      <p>{{ aktInfo.referent }}</p>
    </div>
  </div>
  <div class="gsm-form-nachbringen-aktinformationen_element"
       *ngIf="aktInfo.letzterBearbeiterVorname || aktInfo.letzterBearbeiterNachname">
    <div class="gsm-form-nachbringen-aktinformationen_bezeichnung">
      <p>zuletzt bearbeitet von:</p>
    </div>
    <div class="gsm-form-nachbringen-aktinformationen_wert">
      <p>
        {{ aktInfo.letzterBearbeiterVorname ? aktInfo.letzterBearbeiterVorname : null }}
        {{ aktInfo.letzterBearbeiterNachname ? aktInfo.letzterBearbeiterNachname : null }}
      </p>
    </div>
  </div>
  <div class="gsm-form-nachbringen-aktinformationen_element" *ngIf="aktInfo.letzteBearbeitungDatum">
    <div class="gsm-form-nachbringen-aktinformationen_bezeichnung">
      <p>zuletzt bearbeitet am:</p>
    </div>
    <div class="gsm-form-nachbringen-aktinformationen_wert">
      <p>{{ aktInfo.letzteBearbeitungDatum | amDateFormat: 'DD.MM.YYYY' }}</p>
    </div>
  </div>
  <div class="gsm-form-nachbringen-aktinformationen_element" *ngIf="aktInfo.gesamtZahlung >= 0">
    <div class="gsm-form-nachbringen-aktinformationen_bezeichnung">
      <p>Zahlungen:</p>
    </div>
    <div class="gsm-form-nachbringen-aktinformationen_wert">
      <p>{{ aktInfo.gesamtZahlung | number: '1.2-2':'de-DE' }}</p>
    </div>
  </div>
  <!-- Show only checklist items with status N -->
  <div class="gsm-form-nachbringen-aktinformationen_element"
       *ngIf="aktInfo.checklistItemList.length && checkForStatusN()">
    <div class="gsm-form-nachbringen-aktinformationen_bezeichnung">
      <p>Checklisten Einträge:</p>
    </div>
    <div class="gsm-form-nachbringen-aktinformationen_wert">
      <ng-container *ngFor="let item of aktInfo.checklistItemList; let isLast = last">
        <p *ngIf="item?.status === 'N' || item?.status === 'H'">
          {{ item?.def?.label }}<span *ngIf="item?.status"> - {{ getCheckListItemStatus(item.status) }}</span
        ><span *ngIf="item?.grund"> - {{ item.grund }}</span
        >{{ isLast ? '' : ', ' }}
        </p>
      </ng-container>
    </div>
  </div>
</div>
